import { Phone, ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { scrollToId } from "../lib/smoothScroll";
import { PinMark } from "./PinMark";

export const FinalCTA = () => (
  <section className="relative overflow-hidden brand-gradient py-20 sm:py-28">
    {/* texture */}
    <div
      className="absolute inset-0 opacity-[0.12]"
      style={{
        backgroundImage:
          "radial-gradient(circle at 20% 30%, #ffffff 0.5px, transparent 0.5px), radial-gradient(circle at 70% 60%, #ffffff 0.5px, transparent 0.5px)",
        backgroundSize: "36px 36px, 44px 44px",
      }}
    />
    <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 text-center">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="inline-flex items-center justify-center h-16 w-16 rounded-2xl bg-white/15 backdrop-blur mb-7"
      >
        <PinMark id="ctaPin" className="h-9 w-9" solid />
      </motion.div>

      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-[1.1]"
        data-testid="final-cta-headline"
      >
        Every Recovery Journey Has to Start Somewhere.
      </motion.h2>

      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
        className="mt-5 text-lg text-white/90 leading-relaxed max-w-2xl mx-auto"
      >
        Let us make sure the person taking that first step gets there with someone who understands.
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.18, ease: [0.22, 1, 0.36, 1] }}
        className="mt-9 flex flex-col sm:flex-row gap-3 justify-center"
      >
        <button
          onClick={() => scrollToId("contact")}
          className="inline-flex items-center justify-center gap-2.5 rounded-full px-7 py-3.5 text-base font-semibold text-[#0891B2] bg-white shadow-lg transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl focus:outline-none focus:ring-4 focus:ring-white/50"
          data-testid="final-request-service"
        >
          Request Service <ArrowRight size={18} />
        </button>
        <button
          onClick={() => scrollToId("contact")}
          className="inline-flex items-center justify-center gap-2.5 rounded-full px-7 py-3.5 text-base font-semibold text-white bg-white/15 backdrop-blur border-2 border-white/40 transition-all duration-300 hover:bg-white/25 hover:-translate-y-0.5 focus:outline-none focus:ring-4 focus:ring-white/40"
          data-testid="final-call-text"
        >
          <Phone size={18} /> Call or Text Recovery Rides
        </button>
      </motion.div>

      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.3 }}
        className="mt-10 font-heading text-xl sm:text-2xl font-semibold text-white/95 italic"
      >
        Get There With Someone Who's Been There.
      </motion.p>
    </div>
  </section>
);
